var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CommonContentSingle-white"},[_c('ul',_vm._l((_vm.TableConfigList),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item.TableName))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }